import { fieldMarkers } from "../../common/constants/export";

export const exportFilenameTemplates = {
    searchResults: `Market Dynamics ${fieldMarkers.LISTING_VIEW} - Export - ${fieldMarkers.DATE}`,
    officeBreakdown: `Market Dynamics Office Breakdown for ${fieldMarkers.LISTING_TYPE} - ${fieldMarkers.DATE}`,
    listingsBreakdown: `Market Dynamics Listings Breakdown for ${fieldMarkers.LISTING_TYPE}, ${fieldMarkers.LISTING_STATUS_FILTER} - ${fieldMarkers.DATE}`,
};
